import React from 'react';

import classes from './SidebarSystemMenu.module.scss';
import { SidebarNavLink } from '../components/SidebarNavLink/SidebarNavLink';
import { SIDEBAR_ITEM_TYPE } from '../../../constants/system/headerSettings';
import { SystemMenuItem } from '../../../interfaces/system/SidebarNavConfig';
import { SidebarMenu } from '../components/SidebarMenu/SidebarMenu';
import { SidebarCollapseMenu } from '../components/SidebarCollapseMenu/SidebarCollapseMenu';
import { useSidebarContext } from '../hooks/SidebarContext';

type SidebarSystemMenuProps = {
  items: SystemMenuItem[];
};

const SidebarSystemMenu = ({ items }: SidebarSystemMenuProps) => {
  const { isCollapsed } = useSidebarContext();

  return (
    <div className={classes.systemMenu}>
      {items.map((item) => {
        switch (item.type) {
          case SIDEBAR_ITEM_TYPE.LINK:
            return <SidebarNavLink item={item} key={item.path} />;
          case SIDEBAR_ITEM_TYPE.MENU:
            return <SidebarMenu item={item} key={item.label} />;
          case SIDEBAR_ITEM_TYPE.COLLAPSE_MENU:
            return isCollapsed ? (
              <SidebarMenu item={item} key={item.label} />
            ) : (
              <SidebarCollapseMenu item={item} key={item.label} />
            );
          default:
            return null;
        }
      })}
    </div>
  );
};

export { SidebarSystemMenu };
